import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../stores/authStore';
import { useGuideStore } from '../../stores/guideStore';
import { hasMinRole } from '../../utils/rbac';
import { useGuideSearch } from './useGuideSearch';
import { GUIDE_SECTIONS } from './guideContent';
import styles from './GuidePanel.module.css';

export function GuideSearchResults() {
  const { t } = useTranslation('guide');
  const searchQuery = useGuideStore((s) => s.searchQuery);
  const setActiveArticle = useGuideStore((s) => s.setActiveArticle);
  const user = useAuthStore((s) => s.user);
  const isAdmin = user?.role ? hasMinRole(user.role, 'tenant_admin') : false;
  const results = useGuideSearch(searchQuery, isAdmin);

  if (!searchQuery || searchQuery.trim().length < 2) return null;

  return (
    <div className={styles.searchResults}>
      {results.length === 0 ? (
        <div className={styles.noResults}>{t('noResults', 'No results found.')}</div>
      ) : (
        results.map(({ article, sectionId }) => {
          const section = GUIDE_SECTIONS.find((s) => s.id === sectionId);
          return (
            <button
              key={article.id}
              className={styles.resultItem}
              onClick={() => setActiveArticle(article.id)}
            >
              <div className={styles.resultTitle}>{t(article.titleKey)}</div>
              {section && (
                <div className={styles.resultSection}>{t(section.titleKey)}</div>
              )}
            </button>
          );
        })
      )}
    </div>
  );
}
